export default __webpack_public_path__ + "1543d86c152c1d7a0a7456ec25b9c36d.jpg";